import { createNamespacedHelpers } from '../../../core/services';
import { ADMIN_SERVICES_NAMESPACE } from '../constants';

const { getService: getAdminService, addService: addAdminService } = createNamespacedHelpers(
  ADMIN_SERVICES_NAMESPACE
);

export { getAdminService, addAdminService };
